import styled from "styled-components";
import { media, theme } from "../../theme";

export const ColorPickerDropdownWrapper = styled.div`
    width: 100%;

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        width: 200px;
    }

    .react-colorful {
        margin-top: 20px;
        width: 100%;
        height: 117px;

        ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
            margin-top: 0;
        }
    }
    
    .react-colorful__hue {
        height: 12px;
    }

    .react-colorful__last-control .react-colorful__pointer {
        width: 8px;
        border-radius: 0px;
        border-width: 1px;
    }
`;

export const ColorPickerSwatch = styled.div<{ selected?: boolean }>`
    height: 28px;
    border: none;
    padding: 0;
    border-radius: 4px;
    cursor: pointer;
    outline: none;
    box-shadow: ${({ theme, selected }) => selected ? `0 0 0 2px ${theme.v3.colors.blue}` : undefined};
    border: 1px solid ${({ theme }) => theme.v3.colors.grey88};

    &:hover {
        cursor: pointer;
        box-shadow:  ${({ theme }) => `0 0 0 2px ${theme.v3.colors.blue}`};
    }
`;

export const ColorSwatchOptions = styled.div`
    margin-top: 5px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-right: 30px;
    max-width: 250px;
    width: 100%;

    ${media.phone} {
        margin-bottom: 0;
        width: auto;
    }

    > div {
        width: 10%;
        margin-bottom: 8px;

        ${media.phone} {
            margin-right: 8px;
            width: 28px;
        }
    }
`;

export const ColorSwatchTextInputWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: column;

    ${media.phone} {
        flex-direction: row;
    }

    > div {
        width: 100%;
        margin-bottom: 20px;

        ${media.phone} {
            width: auto;
        }
    }
`;

export const ColorSwatchInputWrapper = styled.div`
    position: relative;
    margin-top: 10px;

    ${media.phone} {
        min-width: 150px;
        min-height: 65px;
        margin-top: 0;
    }
`   

export const V3InputColorPreview = styled.div<{ $largePreview?: boolean}>`
    width: ${({ $largePreview }) => $largePreview ? "28px" : "18px"};
    height: ${({ $largePreview }) => $largePreview ? "28px" : "18px"};
    border-radius: 4px;
    z-index: 1;
    border: 1px solid ${({ theme }) => theme.v3.colors.grey88};
`;
